import { guuid, isNeString } from '@aretheyhappy/utils';
/**
 * Definition for items that appear in an AppSidebar.vue, on the rail or nested below it
 */
class AppSidebarItem {
    /**
     * @param label I18N key of the item's label
     * @param icon Linearicons name, without the "lnr-" prefix
     */
    constructor(label, icon = '') {
        this.uid = guuid();
        this.label = '';
        this.icon = '';
        this.focus_icon = '';
        this.qa_tag = '';
        this.badge = false;
        this.active = false;
        this.disabled = false;
        this.upsell = false;
        this.children = [];
        this.label = label;
        this.icon = icon;
    }
    /**
     * Pass a stable uid when rebuilding items, it decides which section stays selected
     */
    setUid(uid) { this.uid = uid; return this; }
    setLabel(label) { this.label = label; return this; }
    setIcon(icon) { this.icon = icon; return this; }
    /**
     * Icon shown instead of `icon` while the item is the selected section
     */
    setFocusIcon(icon) { this.focus_icon = icon; return this; }
    setQATag(tag) { this.qa_tag = tag; return this; }
    /**
     * Count or I18N key shown on the item. False hides it.
     */
    setBadge(badge) { this.badge = badge; return this; }
    /**
     * Mark the item for the current page. Its top level section becomes the selected one.
     */
    setActive(value) { this.active = value; return this; }
    setDisabled(value) { this.disabled = value; return this; }
    /**
     * Clicking an upsell item emits `upsell` instead of `select`, and its children are not shown
     */
    setUpsell(value) { this.upsell = value; return this; }
    setChildren(children) { this.children = children; return this; }
    get hasChildren() {
        return this.children.length > 0;
    }
    /**
     * True when the item, or any of its descendants, is active
     */
    get isActive() {
        return this.active || this.children.some(child => child.isActive);
    }
    get hasBadge() {
        return this.badge !== false && this.badge !== '';
    }
    get hasQATag() {
        return isNeString(this.qa_tag);
    }
    /**
     * Icon to render, swapping in `focus_icon` while the item is selected
     * @param selected
     */
    getIcon(selected) {
        return selected && isNeString(this.focus_icon) ? this.focus_icon : this.icon;
    }
}
export { AppSidebarItem };
export default AppSidebarItem;
//# sourceMappingURL=AppSidebarItem.js.map